/*

Class for generating an episode of care

http://www.hl7.org/fhir/episodeofcare.html#episodeofcare

{
  "state" : "<code>" // active || pending || archive || delete
  "eocId" : "<String>"
  "type" : [{ code }], // Type/class  - e.g. specialist referral, disease management
  "diagnosis" : [{ // The list of diagnosis relevant to this episode of care
    "condition" : { Reference(Condition) }, // R!  Conditions/problems/diagnoses this episode of care is for
    "role" : { code }, // Role that this diagnosis has within the episode of care (e.g. admission, billing, discharge â€¦)
    "rank" : "<positiveInt>" // Ranking of the diagnosis (for each role type)
  }],
  "subject" : { Reference(Patient) }, // R!  The patient who is the focus of this episode of care
  "orgId" : { Reference(Organization) }, // Organization that assumes care
  "period" : { Period }, // Interval during responsibility is assumed
  "careManager" : { Reference(Practitioner|PractitionerRole) }, // Care manager/care coordinator for the patient
  "birthdate": "<dateTime>",
  "height": "<string>",
  "weight": "<string>",
  "bodyType": "<string>",
  "units": "<string>",
  "skintone": "<string>",
  "sex": "<string>",
  "gender": "<string>",
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');
const { codeSchema } = require('./code.class');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  eocId: Joi.string().required(),
  type: Joi.array().items(codeSchema).optional(),
  subject: Joi.string().optional(),
  orgId: Joi.string().optional(),
  periodStart: Joi.string().optional(),
  periodEnd: Joi.string().optional(),
  careManager: Joi.string().optional(),
  birthdate: Joi.string().required(),
  heightValue: Joi.string().required(),
  heightUnits: Joi.string().required(),
  heightUnitSystem: Joi.string().required(),
  weightValue: Joi.string().required(),
  weightUnits: Joi.string().required(),
  weightUnitSystem: Joi.string().required(),
  bodyType: Joi.string().optional(),
  skintone: Joi.string().optional(),
  sex: Joi.string().required(),
  gender: Joi.string().required(),
  nickname: Joi.string().optional(),
};

// Define class
class Eoc extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.eoc.buildPk(obj.eocId),
      identifiers.eoc.buildSk(obj.state, obj.eocId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] !== undefined) {
        if(obj[key]) {
          this[key] = obj[key];
        }
      }
    }
  }
}

exports.Eoc = Eoc;
exports.eocSchema = schema;